import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import authApi from "@/api/auth";
import stakingApi from "@/api/stakingApi";
import { pagesInfo } from "@/constant/index";

const state = {
    status: {
        success: true,
        message: ""
    },
    //token: localStorage.getItem("token") || "",
    user: {
        balance: 0,
        extraBalanceRental: 0,
        username: null,
    },
    tempBalance: {
        tempMoney: 0,
        warning: false,
    },
    headers: {},
    notifications: [],
    notificationId: "",

};

const getters = {
    authStatus: state => state.status.success,
    user: state => state.user,
    headers: state => state.headers,
};

const mutations = {
    auth_request(state, check) {
        state.status = {
            success: true,
            message: "",
            status: check
        };
    },
    auth_error(state, resp) {
        state.status = {
            success: false,
            message: resp,
            status: false
        };
    },
    auth_response(state, resp) {
        state.status = {
            success: resp.success,
            message: resp.message,
            status: false
        };
        if (resp.message == null) {
            state.status.message = resp.error;
        }
        if (resp.success === true && resp.data !== null) {
            //state.token = resp.data.accessToken;
            //state.user = resp.data;
            // state.headers = {
            //     Authorization: `Bearer ${resp.data.accessToken}`
            // };
        }
    },
    get_user_info(state, user) {
        state.user = user;
    },
    get_temp_balance(state, balanceTemp) {
        state.tempBalance = balanceTemp;
    },
    update_profile_user(state, profile) {
        state.user.fullName = profile.fullName;
        state.user.profilePhoto = profile.profilePhoto;
    },
    logout(state) {
        state.status = {
            success: true,
            message: ""
        };
        //state.token = "";
    },

    update_username(state, data) {
        state.user.username = data.username;
    },

    get_basic_user_information(state, data) {
        if (data.profilePhoto === null || data.profilePhoto.trim() === "") {
            data.profilePhoto = pagesInfo.avatarDefault;
        }
        state.user = data;
        try {
            if(window._paq) window._paq.push(['setUserId', data.username]);
        } catch (error) {
            console.error(error);
        }
    },

    get_user_configuration(state, data) {
        if (data.profilePhoto === null || data.profilePhoto.trim() === "") {
            data.profilePhoto = pagesInfo.avatarDefault;
        }
        state.user = data;
    },


};

const actions = {

    updateProfileUser({ commit }, profile) {
        commit("update_profile_user", profile);
    },

    updateUsername({ commit }, username) {
        commit("update_username", { username });
    },

    basicUserInformationView({ commit }) {
        Promise.all([authApi.getBasicUserInformation(), stakingApi.getBalance()])
            .then((res) => {
                try {
                    let userInfoRes = res[0];
                    let stakingBalanceRes = res[1];
                    commit("get_basic_user_information", {
                        ...userInfoRes.data,
                        stakingBalance: stakingBalanceRes.data
                    });
                } catch (error) {
                    console.error(error);
                }
            }).catch(error => { });
    },

    getTempBalance({ commit }) {
        authApi.getTempBalance()
            .then((res) => {
                let balanceTemp = {
                    tempMoney: 0,
                    warning: false,
                }
                balanceTemp = res.data
                commit("get_temp_balance", balanceTemp);
            })
            .catch(error => {
            });
    },
};

export default { namespaced: true, state, getters, mutations, actions };
